import gql from 'graphql-tag';

const faqsQuery = gql`
  query Faqs {
    fAQs {
      subtitle
      fAQTitle
      bag {
        contentItems {
          ... on FaqQuestionItem {
            displayText
            markdownBody {
              markdown
            }
          }
        }
      }
    }
  }
`;

export {
  faqsQuery,
};